import lottie from 'lottie-web';

var decoLine = document.querySelectorAll('.illumi-deco-line');
decoLine.forEach(function(element) {
    lottie.loadAnimation({
        container: element,
        renderer: 'svg',
        loop: true,
        autoplay: true,
        path: '../wp-content/themes/banta-cafe/illumibanta-assets/assets/video/line.json'
    });
    lottie.setSpeed(0.5);
});

var decoLineMv = document.querySelectorAll('.illumi-deco-line-mv');
decoLineMv.forEach(function(element) {
    lottie.loadAnimation({
        container: element,
        renderer: 'svg',
        loop: true,
        autoplay: true,
        path: '../wp-content/themes/banta-cafe/illumibanta-assets/assets/video/line-mv.json'
    })
    lottie.setSpeed(0.2);
});
